import Request from './request'

const Specifications  = {
  getSpecificationsList(params, callback) {
    Request.get('client-order-specs', params).then(callback).catch(this.bad_answer)
  },
  getSpecificationInfo(id, callback) {
    Request.get('client-order-specs/' + id).then(callback).catch(this.bad_answer)
  },
  putSpecificationInfo(id, params, callback) {
    Request.put('client-order-specs/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  createSpecification(params, callback) {
    Request.post('client-order-specs', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  createNewPositionInSpecification(id, params, callback) {
    Request.post('client-order-specs/' + id + '/item', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  copySpecification(id, params, callback) {
    Request.post('client-order-specs/' + id + '/copy', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  workOrderSpecification(params, callback) {
    Request.post('client-order-specs/work-order', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Specifications
